import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { useQuery } from '../hooks/useQuery';
import { decryptData, handleHttpError } from '../utils';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from '../hooks/useSnackbar';
import {
  CircularProgress,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';

export default function DetalheNotaFiscalStep2() {
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  let { nota_fiscal_id } = useParams();
  const theme = useTheme();

  const { obterOrdemsDeServicoPeloIdDaNota } = useQuery();

  const [isLoading, setIsLoading] = React.useState(true);
  const [ordens, setOrdens] = React.useState([]);

  React.useEffect(() => {
    const id = decryptData(nota_fiscal_id);

    if (!id) {
      navigate(-1);
      return;
    }
    fetchOrdens(id);
  }, []);

  const renderContent = () => {
    if (isLoading) return <CircularProgress />;

    return (
      <>
        {ordens.map((item) => (
          <ListItem key={item.id}>
            <ListItemText
              primary={`Nº O.S: ${item.numero_ordem_servico}`}
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ display: 'inline' }}
                    component="span"
                    variant="body2"
                    color="text.primary"
                  >
                    {`Valor total: ${Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(item.valor_final)}`}
                  </Typography>
                  <br />
                  <Typography
                    sx={{ display: 'inline' }}
                    component="span"
                    variant="body3"
                    color="text.primary"
                  >
                    {`Descrição: ${item.descricao}`}
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
        ))}
      </>
    );
  };

  const fetchOrdens = async (id) => {
    try {
      let { data } = await obterOrdemsDeServicoPeloIdDaNota(id);
      setOrdens(data.data);
      setIsLoading(false);
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    }
  };

  return (
    <Card
      variant="outline"
      style={{
        borderTop: `8px solid ${theme.palette.primary.main}`,
        marginTop: '1.4rem',
      }}
    >
      <CardContent padding="10px">
        <Grid container spacing={1} marginTop={2} display="flex">
          {renderContent()}
        </Grid>
      </CardContent>
    </Card>
  );
}
